import React, { PropsWithChildren } from 'react';
import { Box, Stack } from '@chakra-ui/react';
import { Button, Link, Text } from '@melio/penny';

import { usePartnerConfig } from '@/hooks/partners';
import { useDisclosure } from '@/hooks/useDisclosure';
import { usePlatformIntl } from '@/translations/Intl';
import { SectionHeaderWithButton } from '@/widgets/settings-page/Common/SectionHeaderWithButton.widget';
import { CreateReportModal } from '@/widgets/settings-page/CompanySettingPage/CreateReportModal.widget';

export const PaymentsReportSection = () => {
  const { formatMessage } = usePlatformIntl();
  const { partnerConfig } = usePartnerConfig();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const title = formatMessage('widgets.companySettings.paymentsReportSection.title');
  const content = formatMessage('widgets.companySettings.paymentsReportSection.content', {
    helpLink: (
      <Link
        variant="inline"
        href={partnerConfig.config.links.helpCenter}
        label={formatMessage('widgets.companySettings.paymentsReportSection.linkText')}
        newTab
      />
    ),
  });
  const btnText = formatMessage('widgets.companySettings.paymentsReportSection.btnText');

  return (
    <ReportWidget title={title} buttonText={btnText} onClick={onOpen} content={content}>
      <CreateReportModal isOpen={isOpen} onClose={onClose} />
    </ReportWidget>
  );
};

export type CompanyReportProps = PropsWithChildren<{
  title: string;
  content: React.ReactNode;
  buttonText: string;
  onClick: VoidFunction;
}>;
const ReportWidget: React.FC<CompanyReportProps> = (props: CompanyReportProps) => {
  const { title, content, buttonText, onClick, children } = props;
  return (
    <Stack flexDirection="column" gridGap={'24px'} spacing={0}>
      <SectionHeaderWithButton title={title} />
      <Box>
        <Box mb={6}>
          <Text>{content}</Text>
        </Box>
        <Button variant="tertiary" onClick={onClick} label={buttonText} data-testid="create-report-btn" />
        {children}
      </Box>
    </Stack>
  );
};
